import initCommentForm from './comment-form' ;
import initFormCreate from './form-create';
import initContestsForm from './contests-form';

export default () => {
  $('.comment-form').length && initCommentForm();
  $('.form-create').length && initFormCreate();
  $('.js-contest-work').length && initContestsForm();
}
